<template>
  <sp-broadcast
    :icon="broadcast.icon"
    :level="broadcast.level"
    :collapsable="broadcast.collapsable"
    :dismissable="broadcast.dismissable"
  >
    <span v-if="broadcast.title" slot="title">
      <BaseHtmlContent :html="broadcast.title" />
    </span>
    <div class="broadcast-message-text">
      <BaseHtmlContent :html="broadcast.text" />
    </div>
  </sp-broadcast>
</template>

<script setup>
defineProps({
  broadcast: {
    type: Object,
    required: true,
  },
});
</script>
